import { useMemo } from 'react';
import { scrollProgress } from '../context/ScrollContext';
import { sectionsList } from '../data/projects';

export const SECTIONS = sectionsList;

export default function useScrollSection() {
  return useMemo(() => ({
    getSection: () => {
      const t = scrollProgress.value || 0;
      for (let i = SECTIONS.length - 1; i >= 0; i--) {
        if (t >= SECTIONS[i].start) {
          const section = SECTIONS[i];
          const progress = (t - section.start) / ((section.end - section.start) || 0.01);
          return {
            index: i,
            id: section.id,
            name: section.name,
            progress: Math.min(Math.max(progress, 0), 1),
            total: SECTIONS.length,
          };
        }
      }
      return { index: 0, id: SECTIONS[0].id, name: SECTIONS[0].name, progress: 0, total: SECTIONS.length };
    },
    sections: SECTIONS,
  }), []);
}
